// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PpLpWYKuPU4IkvEQxJVG{position:relative;z-index:1100}", "",{"version":3,"sources":["webpack://./src/sharedComponents/FlaggedImageModal.module.scss"],"names":[],"mappings":"AAEA,sBACE,iBAAA,CACA,YAAA","sourcesContent":["// Portal wrapper stacking context so this modal sits above LegacyDialog\n// (#manageAssetsModal ~1050). Modal has no zIndex prop.\n.stackingWrapper {\n  position: relative;\n  z-index: 1100;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stackingWrapper": "PpLpWYKuPU4IkvEQxJVG"
};
export default ___CSS_LOADER_EXPORT___;
